import React from "react";
import { initialsFromName } from "../core/btw-status-colors";

const PALETTE = [
  "bg-emerald-500",
  "bg-sky-500",
  "bg-violet-500",
  "bg-amber-500",
  "bg-rose-500",
  "bg-indigo-500",
  "bg-teal-500",
  "bg-fuchsia-500",
];

const colorForName = (name = "") => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) | 0;
  return PALETTE[Math.abs(h) % PALETTE.length];
};

const BtwAssigneeAvatar = ({ user, size = "md", className = "" }) => {
  const dim =
    size === "xs"
      ? "h-6 w-6 text-[10px]"
      : size === "sm"
      ? "h-7 w-7 text-xs"
      : size === "lg"
      ? "h-10 w-10 text-sm"
      : "h-8 w-8 text-xs";

  if (!user) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full text-gray-400 ${dim} ${className}`}
        title="Niet toegewezen"
        style={{
          backgroundImage:
            "radial-gradient(circle, transparent 60%, transparent 60%), repeating-linear-gradient(0deg, #d1d5db 0 4px, transparent 4px 8px)",
          border: "1px dashed #d1d5db",
        }}
      >
        <svg className="h-3 w-3" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
            clipRule="evenodd"
          />
        </svg>
      </span>
    );
  }

  if (user.profielFoto) {
    return (
      <img
        src={user.profielFoto}
        alt={user.naam}
        title={user.naam}
        className={`rounded-full object-cover ring-1 ring-white ${dim} ${className}`}
      />
    );
  }

  return (
    <span
      title={user.naam}
      className={`inline-flex items-center justify-center rounded-full font-semibold text-white ${colorForName(
        user.naam,
      )} ${dim} ${className}`}
    >
      {initialsFromName(user.naam)}
    </span>
  );
};

export default BtwAssigneeAvatar;
